<div>
  <h3>{{'mfa.emailTitle' | translate}}</h3>
  <p>{{'mfa.emailText' | translate}}</p>

  @if (mfaService.state.expired) {
  <div class="expire-error">
    <app-icon-warning />&nbsp;
    {{'mfa.expired'| translate: {url: "/"} }}
  </div>
  }

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-input label="mfa.inputLabel" [formGroup]="form" name="code" [required]="true" />
      @if (failed) {
      <div class="error-message">
        <app-icon-warning />&nbsp;
        {{'mfa.invalidCode' | translate}}
      </div>
      }
    <label class="remember">
    <input type="checkbox" formControlName="remember">
    <span>{{'mfa.rememberDevice' | translate}}</span>
    </label>

    <div class="button-group">
      <div class="action">
        @if(loading) {
          <app-spinner></app-spinner>
        } @else {
          <app-button variant="accent">
            <button [disabled]="!form.valid" type="submit" data-testid="mfa-email-submit">
              {{ 'mfa.submit' | translate }}
            </button>
          </app-button>
        }
      </div>

      @if (resendLoading) {
        <app-spinner></app-spinner>
      } @else {
      <app-button>
        <button (click)="resend()" type="button" data-testid="mfa-email-resend">{{'mfa.resend' | translate}}</button>
      </app-button>
      }
    </div>
  </form>

  <div class="back">
    <a routerLink="/mfa" queryParamsHandling="preserve">{{'mfa.back' | translate}}</a>
  </div>
</div>
